import {LATLONGLAYER} from './LatLongLayerTypes'

export const changeLatLongLayer = latLongLayer => {
    return {
        type: LATLONGLAYER,
        load: latLongLayer
    }
}
export const selectNewLatLongLayer = (latLongLayer) => {

    return (dispatch) => {
        dispatch(changeLatLongLayer(latLongLayer))
    }

}